module.exports = __webpack_public_path__ + "4664fb5099f53fe533d974f91e8f05d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/tree-house.png
// module id = 600
// module chunks = 0